module.exports = __webpack_public_path__ + "e4bab52186da61405c4f7338a06d1513.png";